import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import "./PatientCard.scss";

function PatientCard(props) {
  // console.log(props.patientData);
  const history = useHistory();
  const { state } = useLocation();
  console.log(state);
  const handleFHIR = () => {
    if (props.reports !== undefined && props.reports.length > 0) {
      history.push({ pathname: "/fhir", state: props.reports });
    }
  };
  return (
    <div className="content-right">
      <div className="card">
        <div className="card-top">
          <span> Appointments &nbsp;</span>
          <img src="/img/Back - icon.svg" alt="right arrow" />
          <span>
            &nbsp;{" "}
            {props.patientData
              ? props.patientData.name
                ? props.patientData.name
                : "-"
              : state?.patientData?.name}{" "}
          </span>
          <button className="card-close-button">
            <img src="/img/Path 49373.svg" alt="Close Icon" />
          </button>
        </div>
        <div className="patient-info">
          <div className="patient-photo">
            <img
              src={
                props.patientData
                  ? props.patientData.photo
                    ? `data:image/png;base64,${props.patientData.photo}`
                    : "/img/Path 49380.svg"
                  : state?.patientData?.photo !== ""
                  ? `data:image/png;base64,${state.patientData?.photo}`
                  : "/img/Path 49380.svg"
              }
              alt="User Photo"
              height="100"
              width="100"
              className="rounded-patient-photo"
            />
            <p className="patient-name-card">
              {props.patientData
                ? props.patientData.name
                  ? props.patientData.name
                  : "-"
                : state?.patientData?.name}
            </p>
            <p className="patient-description">
              Some Related Information Here...
            </p>
          </div>
        </div>
        <div className="patient-details-container">
          <h5 className="patient-details-title">Patient Details</h5>
          <div className="patient-details-item">
            <span className="patient-details-topic"> Name </span>
            <span className="patient-details-info">
              {" "}
              {props.patientData
                ? props.patientData.name
                  ? props.patientData.name
                  : "-"
                : state?.patientData?.name}{" "}
            </span>
          </div>
          <div className="patient-details-item">
            <span className="patient-details-topic"> Sex </span>
            <span
              className="patient-details-info"
              style={{ filter: "blur(5px)", opacity: 0.5 }}
            >
              {" "}
              {props.patientData
                ? props.patientData.gender
                  ? props.patientData.gender
                  : "-"
                : state?.patientData?.gender}{" "}
            </span>
          </div>
          <div className="patient-details-item">
            <span className="patient-details-topic"> Age </span>
            <span
              className="patient-details-info"
              style={{ filter: "blur(5px)", opacity: 0.5 }}
            >
              {" "}
              {props.patientData
                ? props.patientData.age
                  ? props.patientData.age
                  : "-"
                : state?.patientData?.age}{" "}
            </span>
          </div>
          <div className="patient-details-item">
            <span className="patient-details-topic"> D.O.B </span>
            <span
              className="patient-details-info"
              style={{ filter: "blur(4px)", opacity: 0.5 }}
            >
             {" "}
              {props.patientData
                ? props.patientData.dob
                  ? props.patientData.dob
                  : "-"
                : state?.patientData?.dob}{" "}
            </span>
          </div>
          <div className="patient-details-item">
            <span className="patient-details-topic"> Height </span>
            <span className="patient-details-info">
              {" "}
              {props.patientData
                ? props.patientData.height
                  ? props.patientData.height
                  : "-"
                : state?.patientData?.height}
            </span>
          </div>
          <div className="patient-details-item">
            <span className="patient-details-topic"> Weight </span>
            <span className="patient-details-info">
              {" "}
              {props.patientData
                ? props.patientData.weight
                  ? props.patientData.weight
                  : "-"
                : state?.patientData?.weight}
            </span>
          </div>
          <div className="patient-details-item">
            <span className="patient-details-topic"> Symptoms </span>
            <div>
              <p className="patient-details-symptoms">Fever</p>
              <p className="patient-details-symptoms">Cold</p>
              <p className="patient-details-symptoms">Cough</p>
              <p className="patient-details-symptoms">Congestion</p>
            </div>
          </div>
          <div className="patient-details-item">
            <span className="patient-details-topic"> Reports </span>
            <div>
              <p
                className="patient-details-info"
                onClick={() => handleFHIR()}
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "blue",
                }}
              >
                Click here !!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PatientCard;
